module.exports = __webpack_public_path__ + "img/552118025129095_image.jpg";